import { render, staticRenderFns } from "./DeliveryNoteList.vue?vue&type=template&id=24b90e32"
import script from "./DeliveryNoteList.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports